$(document).ready(function() {

    var urlParams = (function (strParam) {
        var objParams = {};

        function init() {
            objParams = {};
            var arrURLParams = window.location.search.replace('?', '').split('&');
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) {
                return objParams[strParam];
            },
            pull: init
        }
    }());

    // var hideOptions = (function(){

    //     // console.log("pdm tester");
    //     var $variants = $('.pdp-atc__variants');

    //     if (!$variants.length) { return; }

    //     // console.log("url params " + urlParams.get('hide-variants'));

    //     if(urlParams.get('hide-variants').length ){
    //         $variants.hide();
    //     }

    // }());

    var QtyInput = (function () {

        var $qtyInputs = $('.js-qty');

        if (!$qtyInputs.length) { return; }

        var $inputs = $qtyInputs.find('.js-qty__input');
        var $countBtn = $qtyInputs.find('.js-qty__button');

        $inputs.each(function () {

            var min = 1;
            if ($(this).data('min') != undefined) {
                min = parseInt($(this).data('min'));
            }

            if ($(this).val() > min) {
                $(this).siblings('[data-action="subtract"]').attr('disabled', false);
            } else {}

        });

        $('body').on('change', '.js-qty .js-qty__input', function () {
            var $this = $(this);
            var $minusBtn = $this.siblings('[data-action="subtract"]');
            var qty = parseInt($this.val());

            var min = 1;
            if ($this.data('min') != undefined) {
                min = parseInt($this.data('min'));
            }

            if (isNaN(qty) || qty <= min) {
                $this.val(min);
                $minusBtn.attr('disabled', true);
            } else {
                $minusBtn.attr('disabled', false);
                $this.val(qty);
            }

        });

        $('body').on('click', '.js-qty__button', function () {
            var operator = this.dataset.action;
            var $this = $(this);
            var $input = $this.siblings('.js-qty__input');
            var qty = parseInt($input.val());

            var min = 1;
            if ($input.data('min') != undefined) {
                min = parseInt($input.data('min'));
            }

            if (operator == 'add') {
                qty += 1;

                if (qty == (min + 1)) {
                    $this.siblings('[data-action="subtract"]').attr('disabled', false);
                }
            } else {
                qty = qty <= min ? min : qty -= 1;
                if (qty == min) {
                    $this.attr('disabled', true);
                }
            }

            $input.val(qty).trigger('change');
        });

    }());

    var ajaxATC = (function(){

        var $addToCartForm = $('.mproduct form');

        if (!$addToCartForm.length) { return; }

        $addToCartForm.submit(function(e){

            e.preventDefault();
            Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

        })

    }());

    var pdpSlider = (function(){

        var $slider = $('.mproduct__gallery .mproduct__gallery__slider');
        
        if (!$slider.length) { return; }

        var $slider_nav = $('.slider-nav');

        $slider.flickity({
            pageDots: false,
            prevNextButtons: false,
            // wrapAround: true,
        });

        $slider_nav.flickity({
            asNavFor: '.mproduct__gallery .mproduct__gallery__slider',
            draggable: false,
            pageDots: false, 
            // cellAlign: 'center',
            prevNextButtons: false,
            contain: true,
            // initialIndex: 3,
            // wrapAround: true,
        });

    }());

    var pdpSubscriptions = (function(){

        var $subs = $('.custom-subscription');

        if (!$subs.length) { return; }

        var $isSubcription = $subs.find('[name="subcription"]');

        $isSubcription.change(function(){

            var $this = $(this);
            var isSubcription = $this.val();

            var $parent = $this.closest('.custom-subscription');
            var $planSelect = $parent.find('.custom-subscription__plan select');

            console.log('asd');

            if( isSubcription == 'true' ){
                console.log('sub selected');
                $planSelect.attr('name','selling_plan');
            }else{
                console.log('no sub selected');
                $planSelect.attr('name','plan-select');

            }

        });

        // $isSubcription.trigger('change');

        $('.custom-subscription__plan select').change(function(){
            $('.custom-subscription__option--subscription input').trigger('click');
        });

    }());

    var productVariants = (function () {

        // Function to hide non-existent combinations of product variants.
        function hideNonExistent(variant, $form, nonExistentCombinations) {
            $.each(nonExistentCombinations, function (i, combo) {
                // Code to check if the combination exists or not.
                // If not, marks the options as 'unavailable'.
                var match1 = false;
                var match2 = false;
                var match3 = false;
                var message = combo.option1;
                if (combo.option1 == variant.option1) {
                    match1 = true;
                }
                if (
                    combo.option2 == null ||
                    combo.unavailable == '2' ||
                    combo.option2 == variant.option2
                ) {
                    match2 = true;
                    if (combo.option2 != null && combo.unavailable != '2') {
                        message += ' + ' + combo.option2;
                    }
                }
                if (
                    combo.option3 == null ||
                    combo.unavailable == '3' ||
                    combo.option3 == variant.option3
                ) {
                    match3 = true;
                    if (combo.option3 != null && combo.unavailable != '3') {
                        message += ' + ' + combo.option3;
                    }
                }
                if (match1 && match2 && match3) {
                    // console.log(combo);

                    var $options = $form.find('.pdp-atc__group__select option');
                    var $buttons = $form.find(
                        'input[data-option-index="' + combo.unavailable + '"]'
                    );

                    var unavailableSelector = 'option' + combo.unavailable;

                    $options.each(function () {
                        var $option = $(this);
                        if (
                            $option.val() == combo[unavailableSelector] &&
                            !$option.hasClass('unavailable')
                        ) {
                            $option.addClass('unavailable');
                            $option.attr('disabled', true);
                            $option.text(
                                $option.val() + ' (Unavailable in  ' + message + ')'
                            );
                        }
                    });

                    $buttons.each(function () {
                        var $option = $(this);
                        if (
                            $option.val() == combo[unavailableSelector] &&
                            !$option.hasClass('unavailable')
                        ) {
                            $option.attr('disabled', true);
                            $option.addClass('unavailable');
                        }
                    });
                }
            });
        }

        // Function to handle non-existent product combinations.
        function handleNonExistent(options, $form) {

            var variants = JSON.parse($form.find('.pdp-atc__data').text());

            var $groups = $form.find('.pdp-atc__group');
            var $firstSelect = $groups.eq(0).find('.pdp-atc__group__select select');

            var firstOption = $firstSelect.val();
            var replaceVariant = false;

            $.each(variants, function (i, variant) {
                if (variant.option1 == firstOption) {
                    replaceVariant = variant;
                    // console.log(variant);
                    if (variant.available) {
                        return false;
                    }
                }
            });
            
            if (replaceVariant) {
                var index = 0;
                $groups.each(function () {
                    index++;
                    var optionSelector = 'option' + index;
                    $(this)
                        .find('input[value="' + replaceVariant[optionSelector] + '"]')
                        .trigger('click');
                });
            }
        }

        // Function to handle selection of product variant.
        function selectVariant($form, nonExistentCombinations) {
            // Code to handle selection of a variant.
            // It updates the main select value, replaces URL, enables/disables add to cart button,
            // and calls `hideNonExistent` to update the UI accordingly.
            // console.log($form);
            var variants = JSON.parse($form.find('.pdp-atc__data').text());
            // console.log(variants);
            var $atc = $form.find('.pdp-atc__btn');
            var atcText = $atc.data('text');
            var $groups = $form.find('.pdp-atc__group');
            var $mainSelect = $form.find('.pdp-atc__select select');

            var options = [];

            $groups.each(function () {
                var $this = $(this);
                var val = $this.find('.pdp-atc__group__select select').val();
                options.push(val);
                $this.find('.selected-option').text(val);
            });

            var selectedVariant = false;

            $.each(variants, function (i, variant) {
                if (
                    variant.option1 == options[0] &&
                    variant.option2 == options[1] &&
                    variant.option3 == options[2]
                ) {
                    selectedVariant = variant;
                    return false;
                }
            });

            if (selectedVariant) {
                $mainSelect.val(selectedVariant.id);

                if ($form.hasClass('main-atc-form')) {
                    window.history.replaceState(null, null, '?variant=' + selectedVariant.id);
                }
                if (selectedVariant.available) {
                    $atc.attr('disabled', false);
                    $atc.text(atcText);
                } else {
                    $atc.attr('disabled', true);
                    $atc.text('Sold Out');
                }
                // console.log(nonExistentCombinations)
                hideNonExistent(selectedVariant, $form, nonExistentCombinations);
                //do other theme specific things after a variant is selected
                //change image slide, update price etc...
                //selectedVariant is a object including all of its information that you may need

                var $parent = $form.closest('.js-product-container');

                var $price = $parent.find('.js-product-price');
                $price.text(Shopify.formatMoney(selectedVariant.price, '${{amount}}').replace('$', window.currencySymbol + ' '));

                // var $slider = $parent.find('.product-gallery .swiper');
                // var image = selectedVariant.featured_image.src;
                // var newSlide = $slider.find('[data-master="' + image + '"]').data('index');
                // var swiper = $slider[0].swiper;
                // swiper.slideTo(newSlide, 0);

            } else {
                //no mathing variant was found edge case - add descriptive text to atc button and maybe output a message?
                handleNonExistent(options, $form);
            }
        }

        // Function to find and store non-existent combinations of product variants.
        function findNonExistent($form) {

            var $groups = $form.find('.pdp-atc__group');
            var $mainSelect = $form.find('.pdp-atc__select select');
            var nonExistentCombinations = [];

            // Code to find non-existent combinations and add them to `nonExistentCombinations`.
            // It works by examining every combination of available options.
            if (!$groups.length || $groups.length == 1) {
                return;
            }

            function AddUniqueComobo(combo) {
                var alreadyExists = false;
                // there is some "duplication" happening here, need to figure out the best way to prevent it
                //the code below seemed to work, but noticed its removing more than I want
                // $.each(nonExistentCombinations,function(i,ecombo){
                // 	if( ecombo.unavailable == combo.unavailable && ecombo.option1 == combo.option1 ){
                // 		alreadyExists = true;
                // 	}
                // });
                if (!alreadyExists) {
                    nonExistentCombinations.push(combo);
                }
            }

            $groups.eq(0).find('.pdp-atc__group__select option').each(function () {
                var $first = $(this);
                $groups.eq(1).find('.pdp-atc__group__select option').each(function () {
                    var $second = $(this);
                    var combo = {
                        option1: null,
                        option2: null,
                        option3: null,
                        unavailable: null,
                    };
                    if (!$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option2="' + $second.val() + '"]').length) {
                        combo.option1 = $first.val();
                        combo.option2 = $second.val();
                        combo.unavailable = '2';
                        nonExistentCombinations.push(combo);
                    }
                });
                $groups.eq(2).find('.pdp-atc__group__select option').each(function () {
                    var $third = $(this);
                    var combo = {
                        option1: null,
                        option2: null,
                        option3: null,
                        unavailable: null,
                    };
                    if (!$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option3="' + $third.val() + '"]').length) {
                        combo.option1 = $first.val();
                        combo.option3 = $third.val();
                        combo.unavailable = '3';
                        nonExistentCombinations.push(combo);
                    }
                });
            });

            $groups.eq(0).find('.pdp-atc__group__select option').each(function () {
                var $first = $(this);
                $groups.eq(1).find('.pdp-atc__group__select option').each(function () {
                    var $second = $(this);
                    $groups.eq(2).find('.pdp-atc__group__select option').each(function () {
                        var $third = $(this);
                        var combo = {
                            option1: null,
                            option2: null,
                            option3: null,
                            unavailable: null,
                        };
                        if (!$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option2="' + $second.val() + '"][data-option3="' + $third.val() + '"]').length) {
                            combo.option1 = $first.val();
                            combo.option2 = $second.val();
                            combo.option3 = $third.val();
                            combo.unavailable = '3';
                            AddUniqueComobo(combo);
                        }
                    });
                });
                $groups.eq(2).find('.pdp-atc__group__select option').each(function () {
                    var $third = $(this);
                    $groups.eq(1).find('.pdp-atc__group__select option').each(function () {
                        var $second = $(this);
                        var combo = {
                            option1: null,
                            option2: null,
                            option3: null,
                            unavailable: null,
                        };
                        if (!$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option2="' + $second.val() + '"][data-option3="' + $third.val() + '"]').length) {
                            combo.option1 = $first.val();
                            combo.option2 = $second.val();
                            combo.option3 = $third.val();
                            combo.unavailable = '2';
                            AddUniqueComobo(combo);
                        }
                    });
                });
            });

            return nonExistentCombinations;
        };

        // Shopify logic for linking option selectors.
        function updateOptionsInSelector(selectorIndex, $form, optionsMap) {

            // Code to update the available options in a selector based on selected values of other selectors.
            switch (selectorIndex) {
                case 0:
                    var key = 'root';
                    var $selector = $form.find('.pdp-atc__group__select:eq(0) select');
                    break;
                case 1:
                    var key = $form.find('.pdp-atc__group__select:eq(0) select').val();
                    var $selector = $form.find('.pdp-atc__group__select:eq(1) select');
                    break;
                case 2:
                    var key = $form.find('.pdp-atc__group__select:eq(0) select').val();
                    key += ' / ' + $form.find('.pdp-atc__group__select:eq(1) select').val();
                    var $selector = $form.find('.pdp-atc__group__select:eq(2) select');
            }

            var availableOptions = optionsMap[key];

            $selector.find('option').each(function (i, option) {
                var $this = $(this);
                var value = $this.val();
                var $radio = $this.closest('.pdp-atc__group').find('input[type="radio"][value="' + value + '"]');

                $this.removeClass('unavailable');
                $this.attr('disabled', false);
                $radio.removeClass('unavailable');
                $radio.attr('disabled', false);
                if (availableOptions && availableOptions.includes(value)) {
                    $this.text($this.val());
                    $this.removeClass('oos');
                    $radio.removeClass('oos');
                } else {
                    $this.text($this.val() + ' (Soldout)');
                    $this.addClass('oos');
                    $radio.addClass('oos');
                }
            });
        };

        // Shopify logic for linking option selectors.
        function linkOptionSelectors(variants, $form) {

            // Shopify related logic.
            var Shopify = Shopify || {};
            // Required functionality from deprecated options_selection.js.
            // Code to define utility functions used later in Shopify logic.

            // Required functionality from depricated options_selection.js
            (Shopify.arrayIncludes = function (e, t) {
                // Code to update the available options in a selector based on selected values of other selectors.
                for (var n = 0; n < e.length; n++)
                    if (e[n] == t) return !0;
                return !1;
            }),
            (Shopify.uniq = function (e) {
                for (var t = [], n = 0; n < e.length; n++)
                    Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
                return t;
            });

            var optionsMap = {};
            // Code to build mapping between product options and variants.

            // Building our mapping object.
            for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                if (variant.available) {
                    // Gathering values for the 1st drop-down.
                    optionsMap['root'] = optionsMap['root'] || [];
                    optionsMap['root'].push(variant.option1);
                    optionsMap['root'] = Shopify.uniq(optionsMap['root']);
                    // Gathering values for the 2nd drop-down.
                    if (variant.options.length > 1) {
                        var key = variant.option1;
                        optionsMap[key] = optionsMap[key] || [];
                        optionsMap[key].push(variant.option2);
                        optionsMap[key] = Shopify.uniq(optionsMap[key]);
                    }
                    // Gathering values for the 3rd drop-down.
                    if (variant.options.length === 3) {
                        var key = variant.option1 + ' / ' + variant.option2;
                        optionsMap[key] = optionsMap[key] || [];
                        optionsMap[key].push(variant.option3);
                        optionsMap[key] = Shopify.uniq(optionsMap[key]);
                    }
                }
            }

            // Update options right away.
            updateOptionsInSelector(0, $form, optionsMap);

            if (variant.options.length > 1) updateOptionsInSelector(1, $form, optionsMap);

            if (variant.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);

            // When there is an update in the first dropdown.
            $form.find('.pdp-atc__group__select:eq(0) select').change(function () {
                updateOptionsInSelector(1, $form, optionsMap);
                if (variant.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);
                return true;
            });

            // When there is an update in the second dropdown.
            $form.find('.pdp-atc__group__select:eq(1) select').change(function () {
                if (variant.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);
                return true;
            });
        };

        function init($form) {

            //only turned this into a function because of an app that would stop the trigger change from working on the buttons below
            function handleSelectChange($select) {
                // console.log('product form handle select triggered ' + $select.val());
                var $form = $select.closest('form');
                var data = JSON.parse($form.find('.pdp-atc__data').text());
                var nonExistentCombinations = findNonExistent($form);
                linkOptionSelectors(data, $form);
                selectVariant($form, nonExistentCombinations);
            }

            $form.on('change', 'select', function () {
                // console.log('product form select change detected');
                handleSelectChange($(this))
            });

            // Event handler for changing product options via radio buttons.
            $form.on('change', '.pdp-atc__group__buttons input', function () {
                // console.log('product form radio change detected ' + $(this).val());
                // console.log($form)
                // Code to synchronize radio button with corresponding select element.
                var $this = $(this);
                var val = $this.val();
                $this.closest('.pdp-atc__group').find('.pdp-atc__group__select select').val(val);
                handleSelectChange($this.closest('.pdp-atc__group').find('.pdp-atc__group__select select'));
            });

            var $groups = $form.find('.pdp-atc__group');
            var $firstSelect = $groups.eq(0).find('.pdp-atc__group__select select');
            $firstSelect.trigger('change');

        }

        var $forms = $('.pdp-atc');

        $forms.each(function () {
            var $form = $(this);
            init($form);
        });

        return {
            init: init
        }

    })();

  

});

// $( document ).ready(function() {
//     $('.custom-subscription__option').on("click",function(){
//         console.log("Click");
//         $( ".custom-subscription__option" ).removeClass( "active" );
//         $(this).addClass("active");
//   });
// });